var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Chart.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-294074ed\",\"hasScoped\":false,\"transformToRequire\":{\"img\":[\"src\",\"srcset\"]}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Chart.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Chart.vue
// module id = 40sN
// module chunks = 2